import React, { useCallback, useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import {
  Button,
  Flex,
  Grid,
  Label,
  Text,
  FileUpload,
  ErrorMsg,
  Toastify,
} from "atoms";
import { FormInput, FormRadio } from "molecules/FormInput";
import { usePropsoch } from "contexts/Propsoch";
import { useParams } from "react-router-dom";

const validationSchema = Yup.object().shape({
  htLines: Yup.string()
    .required("HT lines is required")
    .typeError("HT lines is required"),
  nala: Yup.string().required("Nala is required").typeError("Nala is required"),
  nalaType: Yup.string()
    .nullable()
    .when("nala", {
      is: (v) => v === "true",
      then: Yup.string()
        .required("Nala type is required")
        .typeError("Nala type is required"),
    }),
  owc: Yup.string().required("Owc is required").typeError("Owc is required"),
  garbageCollectorPlant: Yup.string()
    .required("Garbage collector plant is required")
    .typeError("Garbage collector plant is required"),
  wasteManagementUnit: Yup.string()
    .required("Waste management unit is required")
    .typeError("Waste management unit is required"),
  roadCuttingThrough: Yup.string()
    .required("Road cutting through is required")
    .typeError("Road cutting through is required"),
  metres: Yup.number()
    .min(0, "Value should be greater than 0")
    .typeError("Invalid number")
    .nullable()
    .when("roadCuttingThrough", {
      is: (v) => v === "true",
      then: Yup.number()
        .min(0, "Value should be greater than 0")
        .typeError("Invalid number")
        .required("Metres is required"),
    }),
  gas: Yup.string()
    // .required("Gas is required")
    .typeError("Gas is required"),
  burialGround: Yup.string()
    // .required("Burial ground is required")
    .typeError("Burial ground is required"),
  kharabLand: Yup.string()
    // .required("Kharab land is required")
    .typeError("Kharab land is required"),
  electrical: Yup.array().test(
    "validate_param",
    "Add minimum 1 image",
    (val, valBag) => {
      // if (valBag?.parent?.htLines === "true") {
      //   if (!val?.length) {
      //     return false;
      //   }
      // }
      return true;
    }
  ),
  // .min(1, "Add minimum 1 image")
  // .typeError("Add minimum 1 image")
  // .required("Add minimum 1 image"),
  water: Yup.array().test(
    "validate_param",
    "Add minimum 1 image",
    (val, valBag) => {
      // if (valBag?.parent?.nala === "true") {
      //   if (!val?.length) {
      //     return false;
      //   }
      // }
      return true;
    }
  ),
  // .min(1, "Add minimum 1 image")
  // .typeError("Add minimum 1 image")
  // .required("Add minimum 1 image"),
  wasteDisposal: Yup.array().test(
    "validate_param",
    "Add minimum 1 image",
    (val, valBag) => {
      // if (
      //   valBag?.parent?.owc === "true" ||
      //   valBag?.parent?.garbageCollectorPlant === "true" ||
      //   valBag?.parent?.wasteManagementUnit === "true"
      // ) {
      //   if (!val?.length) {
      //     return false;
      //   }
      // }
      return true;
    }
  ),
  // .min(1, "Add minimum 1 image")
  // .typeError("Add minimum 1 image")
  // .required("Add minimum 1 image"),
  other: Yup.array()
    // .min(1, "Add minimum 1 image")
    .typeError("Image is required"),
  // .required("Master plan is required"),
});
export const SiteChallengesForm = ({
  onNext,
  onPrevious,
  bindHitOnSave,
  fetchProperty,
  rootProperty,
}) => {
  const {
    actions: {
      getPropertyListingSiteChallanges,
      createPropertyListingSiteChallanges,
      updatePropertyListingSiteChallanges,
    },
  } = usePropsoch();

  const { id } = useParams();

  // fetch property
  const [property, setProperty] = useState(null);

  useEffect(() => {
    id &&
      getPropertyListingSiteChallanges(id)?.then((data) => {
        setProperty(data);

        // reformat images
        data &&
          setProperty((prev) => ({
            ...prev,
            electrical: data?.siteImages?.find((i) => i?.type === "electrical")
              ?.images,
            water: data?.siteImages?.find((i) => i?.type === "water")?.images,
            wasteDisposal: data?.siteImages?.find(
              (i) => i?.type === "wasteDisposal"
            )?.images,
            other: data?.siteImages?.find((i) => i?.type === "other")?.images,
          }));
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // submit
  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = useCallback(
    ({
      dirty,
      htLines,
      nala,
      nalaType,
      owc,
      garbageCollectorPlant,
      wasteManagementUnit,
      roadCuttingThrough,
      metres,
      gas,
      burialGround,
      kharabLand,
      electrical,
      water,
      wasteDisposal,
      other,
    }) => {
      setSubmitLoading(true);
      // new nearbyAreas total

      if (dirty) {
        const formattedValues = {
          propertyId: id,
          htLines,
          nala,
          nalaType,
          owc,
          garbageCollectorPlant,
          wasteManagementUnit,
          roadCuttingThrough,
          metres,
          gas,
          burialGround,
          kharabLand,
          siteImages: [
            {
              type: "electrical",
              images: electrical,
            },
            {
              type: "water",
              images: water,
            },
            {
              type: "wasteDisposal",
              images: wasteDisposal,
            },
            {
              type: "other",
              images: other,
            },
          ],
        };
        if (property) {
          updatePropertyListingSiteChallanges(
            formattedValues,
            id,
            rootProperty?.name
          )
            .then(() => {
              Toastify("success", "Site challanges updated");
              fetchProperty()?.then(() => {
                onNext();
              });
            })
            .catch((e) => {
              Toastify("error", "Site challanges not updated");
            })
            .finally(() => {
              setSubmitLoading(false);
            });
        } else {
          createPropertyListingSiteChallanges(
            formattedValues,
            rootProperty?.name
          )
            .then(() => {
              Toastify("success", "Site challanges created");
              fetchProperty()?.then(() => {
                onNext();
              });
            })
            .catch((e) => {
              Toastify("error", "Site challanges not created");
            })
            .finally(() => {
              setSubmitLoading(false);
            });
        }
      } else {
        if (id) {
          onNext();
        }
      }
    },
    [
      createPropertyListingSiteChallanges,
      id,
      updatePropertyListingSiteChallanges,
      onNext,
      property,
      rootProperty,
      fetchProperty,
    ]
  );

  return (
    <Formik
      initialValues={{
        htLines: "",
        nala: "",
        nalaType: "",
        owc: "",
        garbageCollectorPlant: "",
        wasteManagementUnit: "",
        roadCuttingThrough: "",
        metres: "",
        gas: "",
        burialGround: "",
        kharabLand: "",
        electrical: [],
        water: [],
        wasteDisposal: [],
        other: [],
        ...property,
      }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ values, setFieldValue, dirty, submitForm, touched, errors }) => {
        bindHitOnSave(() => {
          setFieldValue("dirty", dirty);
          submitForm();
        });
        return (
          <Form>
            <Grid gridGap="2.4rem" mt="2.4rem">
              <Label
                fontSize="1.8rem"
                color="secondary.700"
                astrixColor="secondary.700"
                text="Electrical"
                req
              />

              <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                <Text color="primary.900" fontFamily="NeometricBold">
                  HT Lines
                </Text>
                <Grid gridTemplateColumns="12rem  12rem" gridGap="2rem">
                  <FormRadio name="htLines" label="Yes" value={true} />
                  <FormRadio name="htLines" label="No" value={false} />
                </Grid>
                {touched?.htLines && errors?.htLines && (
                  <ErrorMsg text={errors?.htLines} />
                )}
              </Grid>
              {values?.htLines && (
                <>
                  <FileUpload
                    files={values?.electrical || []}
                    onUpload={(locations) => {
                      const newProjectImages = [
                        ...(values?.electrical
                          ? JSON.parse(JSON.stringify(values?.electrical)) || []
                          : []),
                        ...locations?.map((i) => ({ image: i, alt: "" })),
                      ];

                      setFieldValue("electrical", newProjectImages);
                    }}
                    onSubmitDescription={({ alt, file }) => {
                      setFieldValue(`electrical.[${file?.index}].alt`, alt);
                    }}
                    onCross={(index) => {
                      const currProjectImages = [
                        ...(values?.electrical
                          ? JSON.parse(JSON.stringify(values?.electrical)) || []
                          : []),
                      ];
                      const total = currProjectImages?.length;

                      const newProjectImages = [
                        ...currProjectImages?.slice(0, index),
                        ...currProjectImages?.slice(index + 1, total),
                      ];

                      setFieldValue("electrical", newProjectImages);
                    }}
                  />
                  {touched?.electrical && errors?.electrical && (
                    <ErrorMsg text={errors?.electrical} />
                  )}
                </>
              )}

              <Label
                fontSize="1.8rem"
                color="secondary.700"
                astrixColor="secondary.700"
                text="Water"
                req
              />
              <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                <Text color="primary.900" fontFamily="NeometricBold">
                  Nala
                </Text>
                <Grid gridTemplateColumns="12rem  12rem" gridGap="2rem">
                  <FormRadio name="nala" label="Yes" value={true} />
                  <FormRadio name="nala" label="No" value={false} />
                </Grid>
                {touched?.nala && errors?.nala && (
                  <ErrorMsg text={errors?.nala} />
                )}
              </Grid>

              {values?.nala && (
                <>
                  <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                    <Text color="primary.900" fontFamily="NeometricBold">
                      Nala Type
                    </Text>
                    <Grid gridTemplateColumns="repeat(3,12rem)" gridGap="2rem">
                      <FormRadio
                        name="nalaType"
                        label="Primary"
                        value="Primary"
                      />
                      <FormRadio
                        name="nalaType"
                        label="Secondary"
                        value="Secondary"
                      />
                      <FormRadio
                        name="nalaType"
                        label="Tertiary"
                        value="Tertiary"
                      />
                    </Grid>
                    {touched?.nalaType && errors?.nalaType && (
                      <ErrorMsg text={errors?.nalaType} />
                    )}
                  </Grid>

                  <FileUpload
                    files={values?.water || []}
                    onUpload={(locations) => {
                      const newProjectImages = [
                        ...(values?.water
                          ? JSON.parse(JSON.stringify(values?.water)) || []
                          : []),
                        ...locations?.map((i) => ({ image: i, alt: "" })),
                      ];

                      setFieldValue("water", newProjectImages);
                    }}
                    onSubmitDescription={({ alt, file }) => {
                      setFieldValue(`water.[${file?.index}].alt`, alt);
                    }}
                    onCross={(index) => {
                      const currProjectImages = [
                        ...(values?.water
                          ? JSON.parse(JSON.stringify(values?.water)) || []
                          : []),
                      ];
                      const total = currProjectImages?.length;

                      const newProjectImages = [
                        ...currProjectImages?.slice(0, index),
                        ...currProjectImages?.slice(index + 1, total),
                      ];

                      setFieldValue("water", newProjectImages);
                    }}
                  />
                  {touched?.water && errors?.water && (
                    <ErrorMsg text={errors?.water} />
                  )}
                </>
              )}

              <Label
                fontSize="1.8rem"
                color="secondary.700"
                astrixColor="secondary.700"
                text="Waste Disposal"
                req
              />
              <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                <Text color="primary.900" fontFamily="NeometricBold">
                  OWC
                </Text>
                <Grid gridTemplateColumns="12rem  12rem" gridGap="2rem">
                  <FormRadio name="owc" label="Yes" value={true} />
                  <FormRadio name="owc" label="No" value={false} />
                </Grid>
                {touched?.owc && errors?.owc && <ErrorMsg text={errors?.owc} />}
              </Grid>
              <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                <Text color="primary.900" fontFamily="NeometricBold">
                  Garbage Collector Plant
                </Text>
                <Grid gridTemplateColumns="12rem  12rem" gridGap="2rem">
                  <FormRadio
                    name="garbageCollectorPlant"
                    label="Yes"
                    value={true}
                  />
                  <FormRadio
                    name="garbageCollectorPlant"
                    label="No"
                    value={false}
                  />
                </Grid>
                {touched?.garbageCollectorPlant &&
                  errors?.garbageCollectorPlant && (
                    <ErrorMsg text={errors?.garbageCollectorPlant} />
                  )}
              </Grid>
              <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                <Text color="primary.900" fontFamily="NeometricBold">
                  Waste Management Unit
                </Text>
                <Grid gridTemplateColumns="12rem  12rem" gridGap="2rem">
                  <FormRadio
                    name="wasteManagementUnit"
                    label="Yes"
                    value={true}
                  />
                  <FormRadio
                    name="wasteManagementUnit"
                    label="No"
                    value={false}
                  />
                </Grid>
                {touched?.wasteManagementUnit &&
                  errors?.wasteManagementUnit && (
                    <ErrorMsg text={errors?.wasteManagementUnit} />
                  )}
              </Grid>

              {(values?.owc ||
                values?.garbageCollectorPlant ||
                values?.wasteManagementUnit) && (
                <>
                  <FileUpload
                    files={values?.wasteDisposal || []}
                    onUpload={(locations) => {
                      const newProjectImages = [
                        ...(values?.wasteDisposal
                          ? JSON.parse(JSON.stringify(values?.wasteDisposal)) ||
                            []
                          : []),
                        ...locations?.map((i) => ({ image: i, alt: "" })),
                      ];

                      setFieldValue("wasteDisposal", newProjectImages);
                    }}
                    onSubmitDescription={({ alt, file }) => {
                      setFieldValue(`wasteDisposal.[${file?.index}].alt`, alt);
                    }}
                    onCross={(index) => {
                      const currProjectImages = [
                        ...(values?.wasteDisposal
                          ? JSON.parse(JSON.stringify(values?.wasteDisposal)) ||
                            []
                          : []),
                      ];
                      const total = currProjectImages?.length;

                      const newProjectImages = [
                        ...currProjectImages?.slice(0, index),
                        ...currProjectImages?.slice(index + 1, total),
                      ];

                      setFieldValue("wasteDisposal", newProjectImages);
                    }}
                  />
                  {touched?.wasteDisposal && errors?.wasteDisposal && (
                    <ErrorMsg text={errors?.wasteDisposal} />
                  )}
                </>
              )}

              <Label
                fontSize="1.8rem"
                color="secondary.700"
                astrixColor="secondary.700"
                text="Road"
                req
              />
              <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                <Text color="primary.900" fontFamily="NeometricBold">
                  Road Cutting through
                </Text>
                <Grid gridTemplateColumns="12rem  12rem" gridGap="2rem">
                  <FormRadio
                    name="roadCuttingThrough"
                    label="Yes"
                    value={true}
                  />
                  <FormRadio
                    name="roadCuttingThrough"
                    label="No"
                    value={false}
                  />
                </Grid>
                {touched?.roadCuttingThrough && errors?.roadCuttingThrough && (
                  <ErrorMsg text={errors?.roadCuttingThrough} />
                )}
              </Grid>

              {values?.roadCuttingThrough && (
                <>
                  <Grid gridTemplateColumns="1fr 1fr" gridGap="2.4rem">
                    <Grid gridRowGap="1.6rem">
                      <Label text="Metres" />
                      <FormInput
                        name="metres"
                        // type="number"
                        placeholder="Enter Metres"
                      />
                    </Grid>
                  </Grid>
                </>
              )}

              <Label
                fontSize="1.8rem"
                color="secondary.700"
                astrixColor="secondary.700"
                text="Other"
              />
              <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                <Text color="primary.900" fontFamily="NeometricBold">
                  Gas
                </Text>
                <Grid gridTemplateColumns="12rem  12rem" gridGap="2rem">
                  <FormRadio name="gas" label="Yes" value={true} />
                  <FormRadio name="gas" label="No" value={false} />
                </Grid>
                {touched?.gas && errors?.gas && <ErrorMsg text={errors?.gas} />}
              </Grid>
              <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                <Text color="primary.900" fontFamily="NeometricBold">
                  Burial Ground
                </Text>
                <Grid gridTemplateColumns="12rem  12rem" gridGap="2rem">
                  <FormRadio name="burialGround" label="Yes" value={true} />
                  <FormRadio name="burialGround" label="No" value={false} />
                </Grid>
                {touched?.burialGround && errors?.burialGround && (
                  <ErrorMsg text={errors?.burialGround} />
                )}
              </Grid>
              <Grid gridTemplateColumns="26rem 1fr" gridRowGap="2.4rem">
                <Text color="primary.900" fontFamily="NeometricBold">
                  Kharab Land
                </Text>
                <Grid gridTemplateColumns="12rem  12rem" gridGap="2rem">
                  <FormRadio name="kharabLand" label="Yes" value={true} />
                  <FormRadio name="kharabLand" label="No" value={false} />
                </Grid>
                {touched?.kharabLand && errors?.kharabLand && (
                  <ErrorMsg text={errors?.kharabLand} />
                )}
              </Grid>
              {(values?.gas || values?.kharabLand || values?.burialGround) && (
                <>
                  <FileUpload
                    files={values?.other || []}
                    onUpload={(locations) => {
                      const newProjectImages = [
                        ...(values?.other
                          ? JSON.parse(JSON.stringify(values?.other)) || []
                          : []),
                        ...locations?.map((i) => ({ image: i, alt: "" })),
                      ];

                      setFieldValue("other", newProjectImages);
                    }}
                    onSubmitDescription={({ alt, file }) => {
                      setFieldValue(`other.[${file?.index}].alt`, alt);
                    }}
                    onCross={(index) => {
                      const currProjectImages = [
                        ...(values?.other
                          ? JSON.parse(JSON.stringify(values?.other)) || []
                          : []),
                      ];
                      const total = currProjectImages?.length;

                      const newProjectImages = [
                        ...currProjectImages?.slice(0, index),
                        ...currProjectImages?.slice(index + 1, total),
                      ];

                      setFieldValue("other", newProjectImages);
                    }}
                  />
                  {touched?.other && errors?.other && (
                    <ErrorMsg text={errors?.other} />
                  )}
                </>
              )}

              <Flex my="2rem" gridGap="1.6rem">
                <Button
                  px="3rem"
                  width="fit-content"
                  variant="primaryOutline"
                  height="4.8rem"
                  onClick={onPrevious}
                >
                  Previous
                </Button>
                <Button
                  px="3rem"
                  width="fit-content"
                  variant="primary"
                  height="4.8rem"
                  type="submit"
                  loading={submitLoading}
                  onClick={() => {
                    setFieldValue("dirty", dirty);
                    submitForm();
                  }}
                >
                  Next
                </Button>
              </Flex>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};
